import { CustomerSupportDetailPage, CustomerSupportPage } from '../components'
import type { CustomerProtectedRendererInput } from './types'

export const renderSupportRoutes = ({ onNavigate, viewModel }: CustomerProtectedRendererInput) => {
  if (viewModel.isSupportRoute) {
    return (
      <CustomerSupportPage
        supportRequests={viewModel.supportRequests}
        supportLoading={viewModel.supportLoading}
        supportError={viewModel.supportError}
        supportSubmitting={viewModel.supportSubmitting}
        supportSuccess={viewModel.supportSuccess}
        supportSubject={viewModel.supportSubject}
        supportMessage={viewModel.supportMessage}
        supportOrderId={viewModel.supportOrderId}
        supportCategory={viewModel.supportCategory}
        supportPriority={viewModel.supportPriority}
        onSupportSubjectChange={viewModel.setSupportSubject}
        onSupportMessageChange={viewModel.setSupportMessage}
        onSupportOrderIdChange={viewModel.setSupportOrderId}
        onSupportCategoryChange={viewModel.setSupportCategory}
        onSupportPriorityChange={viewModel.setSupportPriority}
        onSubmitSupportRequest={viewModel.submitSupportRequest}
        onRetrySupportRequests={viewModel.retrySupportRequests}
        onNavigate={onNavigate}
      />
    )
  }

  if (viewModel.isSupportDetailRoute) {
    return (
      <CustomerSupportDetailPage
        supportRequests={viewModel.supportRequests}
        supportLoading={viewModel.supportLoading}
        supportError={viewModel.supportError}
        supportDetailId={viewModel.supportDetailId}
        onNavigate={onNavigate}
      />
    )
  }

  return null
}
